import { Course } from "@/models/courses.model";
import { SupportEmail } from "@/models/support-email.model";
import { SupportEmailRest } from "@/services/rest/email.rest";
import { BehaviorSubject, Observable, map, take } from "rxjs";

export class RequestSupportService {
  constructor(
    private _support = new SupportEmailRest(),
  ) {}

  private emailSupport$: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  emailSupport: Observable<any> = this.emailSupport$.asObservable();

  sendEmail(data: SupportEmail): void {
    this._support
      .sendEmail(data)
      .pipe(take(1))
      .subscribe({
        next: (response) => {
          this.emailSupport$.next(response);
        },
      });
  }


}
